module.exports = __webpack_public_path__ + "cv.10bc0622.svg";